import { useState } from "react";
import "../css/SearchComponent.css";
import { HiOutlineChevronRight } from "react-icons/hi";
import { useDarkMode } from "../context/darkModeContext";

interface Props {
  handleSubmit: (ip: string) => void;
  ipAddress: string;
}

export default function SearchComponent({ handleSubmit, ipAddress }: Props) {
  const [value, setValue] = useState(ipAddress);
  const { darkMode } = useDarkMode();

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        handleSubmit(value);
      }}
      className={`search-component${darkMode ? "--darkmode" : ""}`}
    >
      <input
        value={value}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setValue(e.target.value)
        }
        className={`search-component-input${darkMode ? "--darkmode" : ""}`}
        autoFocus
        placeholder="123.123.123.123"
      />
      <button
        className={darkMode ? "search-button--darkmode" : "search-button"}
      >
        <HiOutlineChevronRight
          size="1.5rem"
          color="white"
        />
      </button>
    </form>
  );
}
